export const login = {
  title: 'Welcome back to your Arcadia Dashboard.',
  expired: 'Your session has expired. Please sign in again.',
};
